import script from "./MinusIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MinusIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__